module.exports = __webpack_public_path__ + "img/check.7ab85e2c.svg";